import { reactive } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import router from '@/router';
import { menu } from '@/core/data/menu';
import { useLayout } from './layout';
export const useMenu = defineStore('menu', () => {
    const layoutStore = useLayout();
    const { layoutState } = storeToRefs(layoutStore);
    const state = reactive({
        menuItem: menu,
        leftArrow: false,
        rightArrow: true,
        pinedItem: [],
    });
    let scrollTimeoutId = null;
    let scrollId = null;
    // Restore pinned items from localStorage on store creation
    const saved = localStorage.getItem('pinedItems');
    if (saved) {
        try {
            const ids = JSON.parse(saved);
            const restorePinned = (items) => {
                items.forEach(item => {
                    if (item.id && ids.includes(item.id)) {
                        item.isPinned = true;
                        if (!state.pinedItem.includes(item)) {
                            state.pinedItem.push(item);
                        }
                    }
                    if (item.children)
                        restorePinned(item.children);
                });
            };
            restorePinned(state.menuItem);
        }
        catch {
            // Ignore malformed localStorage data
        }
    }
    function sidebarClose() {
        layoutState.value.closeSidebar = true;
    }
    function scrollLeft() {
        state.rightArrow = true;
        if (layoutState.value.margin != 0) {
            layoutState.value.margin = layoutState.value.margin + 500;
        }
        if (layoutState.value.margin == 0) {
            state.leftArrow = false;
        }
    }
    function scrollRight() {
        state.leftArrow = true;
        if (layoutState.value.margin != layoutState.value.scrollMargin) {
            layoutState.value.margin = layoutState.value.margin - 500;
        }
        if (layoutState.value.margin == layoutState.value.scrollMargin) {
            state.rightArrow = false;
        }
    }
    function toggleMenu(item) {
        const cleanPath = router.currentRoute.value.fullPath.split('?')[0];
        if (!item.active) {
            const toggle = (menuItems) => {
                menuItems.forEach(menuItem => {
                    if (menuItems.includes(item)) {
                        menuItem.active = false;
                    }
                    if (menuItem.children) {
                        toggle(menuItem.children);
                    }
                });
            };
            toggle(state.menuItem);
        }
        if (item.path !== cleanPath) {
            item.active = !item.active;
        }
    }
    function pined(item) {
        if (!item.isPinned) {
            item.isPinned = true;
            if (!state.pinedItem.includes(item)) {
                state.pinedItem.push(item);
            }
        }
        else {
            item.isPinned = false;
            state.pinedItem.splice(state.pinedItem.indexOf(item), 1);
        }
        const saveIds = state.pinedItem.map(i => i.id).filter(Boolean);
        localStorage.setItem('pinedItems', JSON.stringify(saveIds));
        scroll(item);
    }
    function scroll(item) {
        if (item && item.id) {
            const scrollDiv = document.getElementById(item.id);
            if (scrollDiv) {
                if (scrollId)
                    clearTimeout(scrollId);
                scrollId = setTimeout(() => {
                    scrollDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
    }
    function setNavActive(target) {
        state.menuItem.forEach(menu => {
            updateActiveState(menu, target);
        });
    }
    function updateActiveState(menu, target) {
        let isActive = false;
        if (menu === target) {
            menu.active = true;
            if (scrollTimeoutId)
                clearTimeout(scrollTimeoutId);
            scrollTimeoutId = setTimeout(() => scroll(menu), 500);
            return true;
        }
        if (menu.children?.length) {
            for (const child of menu.children) {
                const childActive = updateActiveState(child, target);
                if (childActive) {
                    menu.active = true;
                    isActive = true;
                    if (scrollTimeoutId)
                        clearTimeout(scrollTimeoutId);
                    scrollTimeoutId = setTimeout(() => scroll(menu), 2000);
                }
            }
        }
        if (!isActive) {
            menu.active = false;
        }
        return isActive || menu === target;
    }
    function searchMenu(menuItems, term, parentIcon) {
        const results = [];
        for (const item of menuItems) {
            const icon = parentIcon || item.icon;
            const translatedTitle = item.title ? String(i18n.global.t(item.title)).toLowerCase() : '';
            if (translatedTitle.includes(term) && item.type === 'link') {
                results.push({ ...item, icon });
            }
            if (item.children && Array.isArray(item.children)) {
                const childResults = searchMenu(item.children, term, icon);
                results.push(...childResults);
            }
        }
        return results;
    }
    return {
        state,
        sidebarClose,
        scrollLeft,
        scrollRight,
        toggleMenu,
        pined,
        setNavActive,
        searchMenu,
    };
});
